import { Tooltip } from '@material-ui/core'
import Switch from '@mui/material/Switch'
import {
  CheckBox,
  TableFooter,
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  Copy
} from 'components'
import { StatusIcon, MagnifyingGlassIcon } from 'components/Icons'
import { Link } from 'components/Link/Link'
import { useHistory } from 'react-router-dom'
import { IPendingCre } from 'services/NGT/PendingCre'
import { COLORS, FORMAT } from 'utils'
import format from 'utils/format'

interface ITablePendingCre {
  tableData: IPendingCre[]
  page: number
  setPage: (page: number) => void
  setRowsPerPage: (rowsPerPage: number) => void
  selectedContractInfo: (contractId: number) => void
  rowsPerPage: number
  totalItems: number
}
export const TablePendingCre = ({
  tableData,
  setRowsPerPage,
  setPage,
  page,
  rowsPerPage,
  totalItems,
  selectedContractInfo
}: ITablePendingCre) => {
  const history = useHistory()
  const handleChangePage = (newPage: number) => setPage(newPage)
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value))
    setPage(1)
  }

  const handleRedirecionar = (row: IPendingCre) => {
    if (!row.flEmAnalise) {
      history.push({
        pathname: '/ngt/analise-cre',
        state: {
          cdContrato: row.cdContrato,
          dtCompetencia: row.nuAnoMesCompetencia,
          idCreExist: row.idCre,
          pathBack: '/ngt/analise-pendencia-cre',
          tab: 1
        }
      })
    }
  }

  const handleStatus = (status: string) => {
    if (
      status === 'Green' ||
      status === 'Aprovado' ||
      status === 'Liberado' ||
      status === 'L'
    )
      return 'Documentos analisados'
    if (
      status === 'Yellow' ||
      status === 'Analisar' ||
      status === 'Analisando' ||
      status === 'PendenteDocumento' ||
      status === 'P'
    )
      return 'Documentos em processo de Análise'
    if (status === 'Red' || status === 'Recusado' || status === 'B')
      return 'Documentos não analisados no prazo (Backlog)'
    return 'Documentos não analisados no sistema'
  }

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled align="center"></TableCellStyled>
              <TableCellStyled align="center"></TableCellStyled>
              <TableCellStyled align="left">Contrato</TableCellStyled>
              <TableCellStyled minwidth="10em" align="left">
                Fornecedor
              </TableCellStyled>
              <TableCellStyled align="left">Competência</TableCellStyled>
              <TableCellStyled align="left">Tipo Documento</TableCellStyled>
              <TableCellStyled align="left">Nº CRE</TableCellStyled>
              <TableCellStyled align="left">Bloqueio</TableCellStyled>
              <TableCellStyled align="left">Subcont.</TableCellStyled>
              <TableCellStyled align="left">SLA</TableCellStyled>
              <TableCellStyled align="left">Data Anexada</TableCellStyled>
              <TableCellStyled minwidth="10em" align="left">
                Analista
              </TableCellStyled>
              <TableCellStyled align="left">Status</TableCellStyled>
              <TableCellStyled align="left">Ação</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {tableData.length > 0 &&
              tableData.map((row, index) => (
                <TableRowStyled
                  style={{
                    background: row.flSla ? 'rgba(175, 39, 47, .2)' : null,
                    alignItems: 'left'
                  }}
                  key={`${index}-${row.contratoId}`}
                >
                  <TableCellStyled align="left">
                    <CheckBox disabled={row.flEmAnalise} checked={false} />
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    <Copy
                      title="Copiar código de contrato"
                      valueToCopy={row.cdContrato}
                    />
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    <Link
                      onClick={() => selectedContractInfo(row.contratoId)}
                      color={COLORS.blueFonts}
                    >
                      {row.cdContrato}
                    </Link>
                  </TableCellStyled>
                  <TableCellStyled>{row.nmFornecedor}</TableCellStyled>
                  <TableCellStyled align="left">
                    {format.formatMMYYYY(row.nuAnoMesCompetencia)}
                  </TableCellStyled>
                  <TableCellStyled>{row.txDescDoc}</TableCellStyled>
                  <TableCellStyled align="left">
                    {row.cdCodigoCre || '- - - - - - - -'}
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    <Switch checked={row.flCreBloqueado} />
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    <Switch checked={row.flSubContrato} />
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {row.vlSla === null ? '---' : row.vlSla}
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {FORMAT.formatDDMMYYYY(row.dtAnexado)}
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {row.nmAnalista || '- - - - - - '}
                  </TableCellStyled>
                  <Tooltip
                    arrow
                    title={handleStatus(row.txStatusColor)}
                    placement="left"
                  >
                    <TableCellStyled align="center">
                      <StatusIcon value={row.txStatusColor} marginLeft="20px" />
                    </TableCellStyled>
                  </Tooltip>
                  <TableCellStyled
                    onClick={() => {
                      handleRedirecionar(row)
                    }}
                    align="center"
                  >
                    <MagnifyingGlassIcon style={{ justifyContent: 'center' }} />
                  </TableCellStyled>
                </TableRowStyled>
              ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        rows={tableData}
        totalItems={totalItems}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </>
  )
}
